import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h3>Sorry! Route Not Found!</h3>
            <h3>404 Error!</h3>
        </div>
    );
};

export default NoMatch;